import Immutable from 'seamless-immutable'
import * as preferenceActions from '../actions/preferences'
import type {Preferences} from 'lib/definitions/swagger'
import {REHYDRATE} from 'redux-persist/constants'
import {APP_RESET_STATE} from "../actions/app";

export type PreferenceState = {
	email: ?string,
	mobilePhone: ?string,
	preferredName: ?string,
	registeredDevicesCount: ?number,
	notification: ?string,
	remoteCommunication: Preferences,
	lastSeenCommVersion: ?number
}

const initialState : Immutable<PreferenceState> = Immutable({
	email: undefined,
	mobilePhone: undefined,
	preferredName: undefined,
	registeredDevicesCount: undefined,

	notification: undefined,

	remoteCommunication: {},
	lastSeenCommVersion: undefined
})

export default function (state = initialState, action){
	switch(action.type){
		case APP_RESET_STATE:
		case REHYDRATE:
			if(action.payload && action.payload.Preferences){
				return state.set('lastSeenCommVersion', action.payload.Preferences.lastSeenCommVersion)
			}
			return state

		case preferenceActions.PREFERENCES_GET_PERSONAL_DETAILS:
			return state
				.set('email', action.personalDetails.email)
				.set('mobilePhone', action.personalDetails.phone)
				.set('preferredName', action.personalDetails.preferredName)
				.set('registeredDevicesCount', action.personalDetails.registeredDevicesCount)

		case preferenceActions.PREFERENCES_SET_NOTIFICATION:
			return state
				.set('notification', action.notification)

		case preferenceActions.PREFERENCES_SET:
			if(action.key){
				return state.setIn(['remoteCommunication', action.key], action.preferences)
			}else{
				return state.set('remoteCommunication', action.preferences)
			}

		case preferenceActions.COMMUNICATION_SET_SEEN_QUICK_POPUP:
			return state.set('lastSeenCommVersion', action.version)

	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/preferences.js